// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KUR design tokens.
   Extracted from the existing site: Silka type, black nav, ink #1c2026,
   slate #425151, mist #a7b5b7 and the yellow family declared in index.css
   (--kur-yellow / --kur-gold / --kur-amber). New code should read these
   tokens rather than hard-coding values.
   Breakpoints (CSS variables cannot be used in media queries):
   sm 576 · md 768 · lg 1024 · xl 1280 · 2xl 1440 */

:root {
  /* Colour: surfaces */
  --color-black: #000;
  --color-ink: #1c2026;
  --color-ink-deep: #12151a;
  --color-slate: #425151;
  --color-mist: #a7b5b7;
  --color-cloud: #f3f5f5;
  --color-paper: #fff;

  /* Colour: text */
  --color-text: #1a1a1a;
  --color-text-muted: #4a5759;
  --color-text-on-dark: #fff;
  --color-text-muted-on-dark: #c3cfd1;
  --color-link: #0056b3;

  /* Colour: accent (yellow family lives in index.css) */
  --color-accent: var(--kur-gold);
  --color-accent-hover: var(--kur-gold-hover);
  --color-accent-text: var(--kur-amber);

  /* Colour: lines */
  --color-border: #dbe2e3;
  --color-border-on-dark: rgba(255, 255, 255, 0.16);

  /* Typography */
  --font-sans: "Silka", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  /* Display headline face, chosen by KUR. */
  --font-display: Arial, sans-serif;
  --text-display: clamp(2.5rem, 1.4rem + 4.6vw, 5.25rem);
  --text-h1: clamp(2.1rem, 1.3rem + 3vw, 4rem);
  --text-h2: clamp(1.85rem, 1.2rem + 2.2vw, 3.1rem);
  --text-h3: clamp(1.25rem, 1.05rem + 0.9vw, 1.75rem);
  --text-body-lg: clamp(1.05rem, 1rem + 0.3vw, 1.25rem);
  --text-body: 1rem;
  --text-caption: 0.8125rem;
  --text-eyebrow: 0.78rem;
  --leading-tight: 1.08;
  --leading-heading: 1.18;
  --leading-body: 1.6;
  --tracking-eyebrow: 0.14em;
  /* Headings keep the wide tracking of the original KUR site. */
  --tracking-display: 0.04em;
  --tracking-heading: 0.1em;
  --tracking-subheading: 0.05em;
  --tracking-figure: 0.02em;

  /* Spacing */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.5rem;
  --space-6: 2rem;
  --space-7: 3rem;
  --space-8: 4.5rem;
  --section-y: clamp(4.5rem, 3rem + 6vw, 9rem);
  --gutter: clamp(1.25rem, 4vw, 3rem);
  --container: 1240px;

  /* Shape and depth */
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 24px;
  --radius-pill: 999px;
  --shadow-sm: 0 2px 8px rgba(18, 21, 26, 0.08);
  --shadow-lg: 0 24px 60px rgba(18, 21, 26, 0.18);

  /* Motion */
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --dur-fast: 0.2s;
  --dur: 0.45s;

  /* Focus */
  --focus-ring: 0 0 0 3px var(--color-ink), 0 0 0 5px var(--kur-gold);
}

[id] {
  scroll-margin-top: var(--scroll-offset, 96px);
}

:focus-visible {
  outline: 2px solid var(--kur-gold);
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  :root {
    --dur-fast: 0.01s;
    --dur: 0.01s;
  }
  html {
    scroll-behavior: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/DESIGN_SYSTEM/tokens.css"],"names":[],"mappings":"AAAA;;;;;;mDAMmD;;AAEnD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;;EAEnB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;EACnC,qBAAqB;;EAErB,sDAAsD;EACtD,+BAA+B;EAC/B,2CAA2C;EAC3C,qCAAqC;;EAErC,kBAAkB;EAClB,uBAAuB;EACvB,iDAAiD;;EAEjD,eAAe;EACf,8EAA8E;EAC9E,0CAA0C;EAC1C,iCAAiC;EACjC,sDAAsD;EACtD,4CAA4C;EAC5C,iDAAiD;EACjD,mDAAmD;EACnD,qDAAqD;EACrD,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,8DAA8D;EAC9D,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;;EAEzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,mCAAmC;EACnC,mBAAmB;;EAEnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,6CAA6C;EAC7C,+CAA+C;;EAE/C,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;;EAEZ,UAAU;EACV,mEAAmE;AACrE;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* KUR design tokens.\n   Extracted from the existing site: Silka type, black nav, ink #1c2026,\n   slate #425151, mist #a7b5b7 and the yellow family declared in index.css\n   (--kur-yellow / --kur-gold / --kur-amber). New code should read these\n   tokens rather than hard-coding values.\n   Breakpoints (CSS variables cannot be used in media queries):\n   sm 576 · md 768 · lg 1024 · xl 1280 · 2xl 1440 */\n\n:root {\n  /* Colour: surfaces */\n  --color-black: #000;\n  --color-ink: #1c2026;\n  --color-ink-deep: #12151a;\n  --color-slate: #425151;\n  --color-mist: #a7b5b7;\n  --color-cloud: #f3f5f5;\n  --color-paper: #fff;\n\n  /* Colour: text */\n  --color-text: #1a1a1a;\n  --color-text-muted: #4a5759;\n  --color-text-on-dark: #fff;\n  --color-text-muted-on-dark: #c3cfd1;\n  --color-link: #0056b3;\n\n  /* Colour: accent (yellow family lives in index.css) */\n  --color-accent: var(--kur-gold);\n  --color-accent-hover: var(--kur-gold-hover);\n  --color-accent-text: var(--kur-amber);\n\n  /* Colour: lines */\n  --color-border: #dbe2e3;\n  --color-border-on-dark: rgba(255, 255, 255, 0.16);\n\n  /* Typography */\n  --font-sans: \"Silka\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  /* Display headline face, chosen by KUR. */\n  --font-display: Arial, sans-serif;\n  --text-display: clamp(2.5rem, 1.4rem + 4.6vw, 5.25rem);\n  --text-h1: clamp(2.1rem, 1.3rem + 3vw, 4rem);\n  --text-h2: clamp(1.85rem, 1.2rem + 2.2vw, 3.1rem);\n  --text-h3: clamp(1.25rem, 1.05rem + 0.9vw, 1.75rem);\n  --text-body-lg: clamp(1.05rem, 1rem + 0.3vw, 1.25rem);\n  --text-body: 1rem;\n  --text-caption: 0.8125rem;\n  --text-eyebrow: 0.78rem;\n  --leading-tight: 1.08;\n  --leading-heading: 1.18;\n  --leading-body: 1.6;\n  --tracking-eyebrow: 0.14em;\n  /* Headings keep the wide tracking of the original KUR site. */\n  --tracking-display: 0.04em;\n  --tracking-heading: 0.1em;\n  --tracking-subheading: 0.05em;\n  --tracking-figure: 0.02em;\n\n  /* Spacing */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.5rem;\n  --space-6: 2rem;\n  --space-7: 3rem;\n  --space-8: 4.5rem;\n  --section-y: clamp(4.5rem, 3rem + 6vw, 9rem);\n  --gutter: clamp(1.25rem, 4vw, 3rem);\n  --container: 1240px;\n\n  /* Shape and depth */\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 24px;\n  --radius-pill: 999px;\n  --shadow-sm: 0 2px 8px rgba(18, 21, 26, 0.08);\n  --shadow-lg: 0 24px 60px rgba(18, 21, 26, 0.18);\n\n  /* Motion */\n  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);\n  --dur-fast: 0.2s;\n  --dur: 0.45s;\n\n  /* Focus */\n  --focus-ring: 0 0 0 3px var(--color-ink), 0 0 0 5px var(--kur-gold);\n}\n\n[id] {\n  scroll-margin-top: var(--scroll-offset, 96px);\n}\n\n:focus-visible {\n  outline: 2px solid var(--kur-gold);\n  outline-offset: 3px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --dur-fast: 0.01s;\n    --dur: 0.01s;\n  }\n  html {\n    scroll-behavior: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
